import styled from "styled-components";

const Button = styled.button`
  background-image: linear-gradient(
    45deg,
    rgb(93, 71, 240) 0%,
    rgb(82, 155, 224) 100%
  );
  color: white;
  position: absolute;
  z-index: 2;
  bottom: 20px;
  width: calc(100% - 40px);
  left: 0;
  right: 0;
  margin: 0 auto;
  border: none;
  font-size: 14px;
  border-radius: 3px;
  padding: 10px;
  outline: none;
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js